import React, { useEffect, useState, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchIpDiscovery,
  createHOst,
  deleteIp,
  uploadIp,
  fetchIpDiscoveryTotal,
  fetchIpDiscoveryGraph,
  fetchIpDiscoveryAction,
  allPort,
  allCountry,
  allCloud,
  addIp
} from "../../actions/inventory";
import { Link, useParams } from "react-router-dom";
import "../../assets/css/recommendation-modal.css";
import Tooltip from "../common/toolTip";
import { VectorMap } from "react-jvectormap";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from "../Pagination/Pagination";
import moment from "moment";
import ReactSelect from "react-select";
import { Modal } from "@material-ui/core";
import $, { data } from "jquery";
import { toastr } from "react-redux-toastr";
import ScanMessage from "../common/scanningMessage";
import AccessPage from "../Shared/accessPage";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import Loader from "../Shared/loader";
import imgOne from "../../assets/images/database-server-2--server-network-internet.png";
import imgTwo from "../../assets/images/Earth-1--Streamline-Core.png";
import imgThree from "../../assets/images/Pet-Food--Streamline-Core.png";
import imgFour from "../../assets/images/usb-port--cables-cable-device-port-electronics-cords-cord-usb-connection.png";
import imgFive from "../../assets/images/Ai-Database-Spark--Streamline-Core.png";
import imgSix from "../../assets/images/Wifi-Antenna--Streamline-Core.png";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
  },
  paper: {
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
    minWidth: "600px",
    minHeight: "300px",
  },
}));

const AssetDiscovery = () => {
  var ipCriticalityEnable = false;
  const { orgId } = useParams();
  const dispatch = useDispatch();
  const myRef = useRef(null);

  const [isModal, setModal] = useState(false);
  const [isModaltwo, setModalTwo] = useState(false);
  const [isModalThree, setModalThree] = useState(false);
  const [isModalhost, setModalHost] = useState(false);
  const [hosts, setHosts] = useState([]);
  const [isModalTrue, setModalSet] = useState(false);
  const [modalHeading, setModalHeading] = useState("");
  const [modalBody, setModalBody] = useState([]);
  const [applyCountrySearch, setApplyCountrySearch] = useState([]);
  const [applyCloudSearch, setApplyCloudSearch] = useState([]);
  const [applyCriticality, setApplyCriticality] = useState([]);
  const [applyPortSearch, setApplyPortSearch] = useState([]);
  const [certModal, setCertModal] = useState(false);
  const [certModalBody, setCertModalBody] = useState();
  const [page, setPage] = useState(1);
  const [firstLoad, setFirstLoad] = useState(true);
  const [PageSize, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [filterData, setfilterData] = useState("all");
  const [addIpModel, setAddIpModel] = useState(false);
  const [modalStyle] = useState(getModalStyle);
  const [addHost, setHost] = useState("");
  const classes = useStyles();
  const [ipRemoveModal, setIpRemoveModal] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [category, setCategory] = useState("all");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [Ips, setIps] = useState([]);
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const [limit, setLimit] = useState(10);

  const [ipId, setIpId] = useState("");
  const queryParameters = new URLSearchParams(window.location.search);
  const latest = queryParameters.get("latest");
  const auth = useSelector((state) => state?.auth?.user);
  const [loading, setLoading] = useState(false);
  const [domainFilter, setDomainFilter] = useState("all");
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [expandedServiceRows, setExpandedServiceRows] = useState(new Set());
  const [from, setFrom] = useState("");
  const [till, setTill] = useState("");
  const [updatedAtFrom, setUpdatedAtFrom] = useState("");
  const [updatedAtTo, setUpdatedAtTo] = useState("");
  const showSpinner = () => {
    setLoading(true);
  };

  const hideSpinner = () => {
    setLoading(false);
  };
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });

  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.asm?.e;
  });

  if (id == "62088cb69f0b0c58a632706a" || id == "68551a95f1ab89b9ed1edef0") {
    ipCriticalityEnable = true;
  }

  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  let domain = client?.website?.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "");
  if (domain?.charAt(domain.length - 1) == "/") {
    domain = [domain.substr(0, domain.length - 1)];
  } else {
    domain = [domain];
  }
  if (client?.domains && client.domains.length > 0) {
    domain = client.domains;
  }

  let table = useSelector((state) => state?.inventory?.ipdiscovery?.data?.data);
  let tableTotal = useSelector(
    (state) => state?.inventory?.ipdiscovery?.data?.totalRecords
  );
  let countRes = useSelector((state) => state?.inventory?.assetstotal?.data);
  let lengthOfPort = useSelector(
    (state) => state?.inventory?.allport?.data?.ports
  );
  let lengthOfLocation = useSelector(
    (state) => state?.inventory?.allcountry?.data?.countries
  );
  let lengthOfcloudLocations = useSelector(
    (state) => state?.inventory?.allcloud?.data?.cloudProviders
  );

  const scanCompleted = useSelector((state) => state.inventory.scanCompleted);
  const distinctLocationData = useSelector(
    (state) => state?.inventory?.assetsgraph?.data?.scanDetails
  );

  let counts;

  const markers = [
  ];

  const hostOpen = (res) => {
    setHosts(res);
    setModalHost("Form Wizard modal host");
  };

  const riskOpen = (res) => {
    setHosts(res);
    setModalHost("Port Wizard modal host");
  };

  const values = {

  };

  const onModalOpen = () => {
    setModalSet(true);
  };

  const addModal = () => {
    setModalTwo("Form Wizard modal two");
  };

  const multiIp = (ip) => {
    const allIds = ip?.map((item) => item.ip);

    const data = {
      action: "markAsIncorrectIp",
      ips: allIds,
      actionNote: "",
    };
    fetchIpDiscoveryAction(
      id,
      dispatch,
      page,
      category,
      applyPortSearch,
      applyCountrySearch,
      applyCloudSearch,
      search,
      data,
      domainFilter,
      applyCriticality,
      'desc',
      domainFilter === 'all' ? '' : domainFilter,
      from,
      till
    );
    setSelectedValue("pleaseSelect");
    setActionNote("");
  }

  let mapData = table;
  let currentTableData = [];

  if (mapData) {
    currentTableData = mapData;
  }

  useEffect(() => {
    if (orgId) {
      fetchIpDiscovery(
        orgId,
        dispatch,
        page,
        category,
        applyPortSearch,
        applyCountrySearch,
        applyCloudSearch,
        search,
        domainFilter,
        applyCriticality,
        limit,
        'desc',
        domainFilter === 'all' ? '' : domainFilter?.toLowerCase(),
        from,
        till,
        updatedAtFrom,
        updatedAtTo
      );
    } else {
      fetchIpDiscovery(
        id,
        dispatch,
        page,
        category,
        applyPortSearch,
        applyCountrySearch,
        applyCloudSearch,
        search,
        domainFilter,
        applyCriticality,
        limit,
        'desc',
        domainFilter === 'all' ? '' : domainFilter?.toLowerCase(),
        from,
        till,
        updatedAtFrom,
        updatedAtTo
      );
    }
  }, [
    id,
    dispatch,
    page,
    category,
    applyPortSearch,
    applyCountrySearch,
    applyCloudSearch,
    search,
    domainFilter,
    orgId,
    applyCriticality,
    limit,
    from,
    till,
    updatedAtFrom,
    updatedAtTo
  ]);

  useEffect(() => {
    setTotalItems(tableTotal);
  }, [tableTotal]);

  useEffect(() => {
    if (table == null) {
      showSpinner();
    } else {
      hideSpinner();
    }
  }, [table]);

  useEffect(() => {
    allPort(id, dispatch, category);
  }, [id, dispatch, category]);

  useEffect(() => {
    allCountry(id, dispatch, category);
  }, [id, dispatch, category]);

  useEffect(() => {
    allCloud(id, dispatch, category);
  }, [id, dispatch, category]);

  useEffect(() => {
    fetchIpDiscoveryTotal(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    fetchIpDiscoveryGraph(id, dispatch);
  }, [id, dispatch]);

  const tableCheck = table?.map(
    (res) => res?._id === table.find((item) => item?.ip === res?._id)?.ip
  );
  const result = tableCheck?.every((check) => check);

  let port = [];
  if (result) {
    port =
      table?.flatMap((res) =>
        res?.port?.flatMap((restwo) => restwo?.map((item) => item?.port))
      ) || [];
  } else {
    port = table?.map((res) => res?.services?.map((res) => res?.port));
  }

  const networkService = table?.data?.map((res) =>
    res?.services?.map((res) => res?.service_name)
  );

  const services = table?.data?.map((res) =>
    res.services.map((res) => res?.service_name)
  );

  const createHost = () => {
    let host = $("#hostName").val();
    if (!host) {
      toastr.error("Error", "Please enter host address.");
      return false;
    }
    createHOst({ organisationId: id, ip: host }, dispatch);
  };

  const modalBodyData = (
    <div style={modalStyle} className={classes.paper}>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
        }}
      >
        <button
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => setAddIpModel(false)}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div>
        <h2>Add Targets</h2>
        <div>
          <div className="row">
            <label className="col-form-label col-md-4">Host Name</label>
            <div className="col-md-7">
              <input
                type="text"
                className="form-control"
                // style={{ width: 200 }}
                id="hostName"
                placeholder="Add Host"
                value={addHost}
                onChange={(e) => setHost(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="text-right mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={() => createHost()}
                >
                  Add Host
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  let ports = [];
  for (let i = 0; i < port?.length; i++) {
    for (let j = 0; j < port[i]?.length; j++) {
      ports.push(port[i][j]);
    }
  }

  let servicesNetwork = [];
  for (let i = 0; i < networkService?.length; i++) {
    for (let j = 0; j < networkService[i]?.length; j++) {
      servicesNetwork.push(networkService[i][j]);
    }
  }

  let service = [];
  for (let i = 0; i < services?.length; i++) {
    for (let j = 0; j < services[i]?.length; j++) {
      service.push(services[i][j]);
    }
  }

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event, ip, ips) => {
    let ids = [];
    ids.push(_id);
    if (event === "markAsRemidiated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated?",
        type: "green",
        buttons: {
          ok: {
            text: "Yes",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              const data = {
                action: "markAsRemidiated",
                ipIds: selectedIds.length === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              fetchIpDiscoveryAction(
                id,
                dispatch,
                page,
                category,
                applyPortSearch,
                applyCountrySearch,
                applyCloudSearch,
                search,
                data,
                domainFilter,
                applyCriticality,
                'desc',
                domainFilter,
                from,
                till
              );
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setSelectedIds([]);
              setPage(1);
            },
          },
          cancel: function () {
          },
        },
      });
    }

    if (event === "markAsIncorrectIp") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this IP as incorrect?",
        type: "orange",
        buttons: {
          ok: {
            text: "Yes",
            btnClass: "btn-warning",
            keys: ["enter"],
            action: function () {
              const filteredData = ips.filter(obj => selectedIds.includes(obj._id));
              const allIds = filteredData.length === 0 ? ip : filteredData.map((item) => item.ip);
              const data = {
                action: "markAsIncorrectIp",
                ips: allIds,
                actionNote: "",
              };
              fetchIpDiscoveryAction(
                id,
                dispatch,
                page,
                category,
                applyPortSearch,
                applyCountrySearch,
                applyCloudSearch,
                search,
                data,
                domainFilter,
                applyCriticality,
                'desc',
                domainFilter === 'all' ? '' : domainFilter,
                from,
                till
              );
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setMultiCheckTrue(false);
              setPage(1);
            },
          },
          cancel: function () {
          },
        },
      });
    }

    if (event === "markAsCorrectIp") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you want to mark this IP as correct?",
        type: "green",
        buttons: {
          ok: {
            text: "Yes",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              const filteredData = ips.filter(obj => selectedIds.includes(obj._id));
              const allIds = filteredData.length === 0 ? ip : filteredData.map((item) => item.ip);
              const data = {
                action: "markAsCorrectIp",
                ips: allIds,
                actionNote: "",
              };
              fetchIpDiscoveryAction(
                id,
                dispatch,
                page,
                category,
                applyPortSearch,
                applyCountrySearch,
                applyCloudSearch,
                search,
                data,
                domainFilter,
                applyCriticality,
                'desc',
                domainFilter === 'all' ? '' : domainFilter,
                from,
                till
              );
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setMultiCheckTrue(false);
              setPage(1);
            },
          },
          cancel: function () {
          },
        },
      });
    }
  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      ipIds: selectedIds == 0 ? ids : selectedIds,
    };
    fetchIpDiscoveryAction(
      id,
      dispatch,
      page,
      category,
      applyPortSearch,
      applyCountrySearch,
      applyCloudSearch,
      search,
      data,
      domainFilter,
      applyCriticality,
      'desc',
      domainFilter === 'all' ? '' : domainFilter,
      from,
      till
    );
    setSelectedIds([]);
    setPage(1);
  };

  const submit = () => {
    const data = {
      action: action,
      ipIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchIpDiscoveryAction(
      id,
      dispatch,
      page,
      category,
      applyPortSearch,
      applyCountrySearch,
      applyCloudSearch,
      search,
      data,
      domainFilter,
      applyCriticality,
      'desc',
      domainFilter === 'all' ? '' : domainFilter,
      from,
      till
    );
    setModalTwo("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
    setPage(1);
  };

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/digital-inventory/${id}/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}IP Details.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const removeKeyword = (index) => {
    let ip = [...Ips];
    ip.splice(index, 1);
    setIps(ip);
  }

  const addIps = () => {
    let val = $("#ips").val()
    setIps([...Ips, val])
    $("#ips").val('')
  }

  const submitIps = () => {
    let ips = {
      "ips": Ips
    }
    addIp(id, dispatch, ips)
    setModalThree('')
    setIps([])
  }

  return (
    <div className="container-fluid">
      {loading && <Loader />}
      <AccessPage></AccessPage>
      <Modal
        open={addIpModel}
        onClose={() => setAddIpModel(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {modalBodyData}
      </Modal>
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">IP Discovery </h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                    <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                  </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      <Link to={`/dashboard/vendor/${vendorId}`}
                      >{vendorName}</Link>
                    </li> : ''
                }
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "white" }}
                >
                  IP Discovery & Open Port
                </li>
              </ol>
              <br />
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 d-flex justify-content-end">
            <span className="mr-2">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setIsRecommendationModal(true);
                }}
                href="#"
                className="btn btn-sm btn-primary mr-1"
                style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
              >
                <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                Recommendation
              </a>
            </span>
            {mapData?.length === 0 ? null : (
              <div>
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              </div>
            )}
            {/* {auth.accessLevel === "super-admin" && (
              <div
              >
                <label className="custom-file-label-upload"
                  onClick={() => {
                    setModalThree('Form Wizard modalThree')
                  }}
                >
                  Add IP Address
                </label>
              </div>
            )} */}
          </div>
        </div>
      </div>

      {typeof scanCompleted !== "undefined" && !scanCompleted && (
        <div className="card border-success">
          <ScanMessage />
        </div>
      )}

      <div className="row clearfix">
        <div className="col-lg-6 col-md-12 col-sm-12">
          <div className="row clearfix">
            <div className="col-sm-4">
              <div className="card w_card3">
                <div
                  className="body knowCard"
                >
                  <div className="text-center">
                    <span className="iconBoxDashboard">
                      <img src={imgOne} className="img-fluid" />
                    </span>
                    <h5 className="m-t-20 mb-0">
                      {countRes?.totalHostsOrIPs || 0}
                    </h5>
                    <p className="text-muted1 mt-1">Host/IP Discovered</p>
                    {/* <a
                      style={{ color: "#ffffff" }}
                      className="btn btn-info btn-round"
                    >
                      Find more
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="card w_card3">
                <div
                  className="body knowCard"
                // style={{ cursor: "pointer" }}
                // onClick={() => setModalData("Hosts Location")}
                >
                  <div className="text-center">
                    <span className="iconBoxDashboard">
                      <img src={imgTwo} className="img-fluid" />
                    </span>
                    <h5 className="m-t-20 mb-0">
                      {countRes?.totalCountries || 0}
                    </h5>
                    <p className="text-muted1 mt-1">Country</p>
                    {/* <a
                      style={{ color: "#ffffff" }}
                      className="btn btn-success btn-round"
                    >
                      Find more
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="card w_card3">
                <div
                  className="body knowCard"
                // style={{ cursor: "pointer" }}
                // onClick={() => setModalData("Cloud / ISP Provider")}
                >
                  <div className="text-center">
                    <span className="iconBoxDashboard">
                      <img src={imgThree} className="img-fluid" />
                    </span>
                    <h5 className="m-t-20 mb-0">
                      {countRes?.totalCloudOrISPProviders || 0}
                    </h5>
                    <p className="text-muted1 mt-1">Cloud / ISP Provider</p>
                    {/* <a
                      style={{ color: "#ffffff" }}
                      className="btn btn-primary btn-round"
                    >
                      Find more
                    </a> */}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-4">
              <div className="card w_card3">
                <div
                  className="body knowCard"
                // style={{ cursor: "pointer" }}
                // onClick={() => executeScroll("vulnerable")}
                >
                  <div className="text-center">
                    <span className="iconBoxDashboard">
                      <img src={imgFour} className="img-fluid" />
                    </span>
                    <h5 className="m-t-20 mb-0">
                      {countRes?.totalOpenPorts || 0}
                    </h5>
                    <p className="text-muted1 mt-1">Open Ports</p>
                    {/* <a
                      style={{ color: "#ffffff" }}
                      className="btn btn-primary btn-round"
                    >
                      Find more
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="card w_card3">
                <div
                  className="body knowCard"
                // style={{ cursor: "pointer" }}
                // onClick={() => executeScroll("operatingSystem")}
                >
                  <div className="text-center">
                    <span className="iconBoxDashboard">
                      <img src={imgFive} className="img-fluid" />
                    </span>
                    <h5 className="m-t-20 mb-0">
                      {countRes?.totalOperatingSystems || 0}
                    </h5>
                    <p className="text-muted1 mt-1">Operating Systems</p>
                    {/* <a
                      style={{ color: "#ffffff" }}
                      className="btn btn-primary btn-round"
                    >
                      Find more
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="card w_card3">
                <div
                  className="body knowCard"
                // style={{ cursor: "pointer" }}
                // onClick={() => setModalData("Network Services")}
                >
                  <div className="text-center">
                    <span className="iconBoxDashboard">
                      <img src={imgSix} className="img-fluid" />
                    </span>
                    <h5 className="m-t-20 mb-0">
                      {countRes?.totalNetworkServices || 0}
                    </h5>
                    <p className="text-muted1 mt-1">Network Services</p>
                    {/* <a
                      style={{ color: "#ffffff" }}
                      className="btn btn-primary btn-round"
                    >
                      Find more
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12">
          <div className="card">
            <div className="body">
              <div id="world-map-markers" className="jvector-map main-map">
                <VectorMap
                  containerStyle={{
                    height: "300px",
                  }}
                  map={"world_mill"}
                  backgroundColor="transparent"
                  borderColor="#fff"
                  borderOpacity={0.25}
                  borderWidth={0}
                  color="#e6e6e6"
                  regionStyle={{ initial: { fill: "#6c757d" } }}
                  markerStyle={{
                    initial: {
                      r: 5,
                      fill: "#766CFF",
                      "fill-opacity": 1,
                      stroke: "#000",
                      "stroke-width": 1,
                      "stroke-opacity": 0.4,
                    },
                  }}
                  markers={distinctLocationData}
                  series={{
                    regions: [
                      {
                        values: values,
                        attribute: "fill",
                      },
                    ],
                  }}
                  hoverOpacity={null}
                  normalizeFunction="linear"
                  zoomOnScroll={false}
                  scaleColors={["#000000", "#000000"]}
                  selectedColor="#000000"
                  selectedRegions={[]}
                  enableZoom={false}
                  hoverColor="#fff"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-12 col-md-12">
          <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
            <li className="nav-item">
              <a
                className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                  }`}
                onClick={() => {
                  setCategory("all");
                  setPage(1);
                  setSearch("");
                  setApplyCountrySearch([]);
                  setApplyCloudSearch([]);
                  setApplyPortSearch([]);
                  setSelectedIds([]);
                }}
              >
                Current
              </a>
            </li>
            {/* <li className="nav-item">
              <a
                className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                  }`}
                onClick={() => {
                  setCategory("risk-accepted");
                  setPage(1);
                  setSearch("");
                  setApplyCountrySearch([]);
                  setApplyCloudSearch([]);
                  setApplyPortSearch([]);
                  setSelectedIds([]);
                }}
              >
                Risk Accepted
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a
                className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                  }`}
                onClick={() => {
                  setCategory("false-positive");
                  setPage(1);
                  setSearch("");
                  setApplyCountrySearch([]);
                  setApplyCloudSearch([]);
                  setApplyPortSearch([]);
                  setSelectedIds([]);
                }}
              >
                False Positive
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a
                className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                  }`}
                onClick={() => {
                  setCategory("remidiated");
                  setPage(1);
                  setSearch("");
                  setApplyCountrySearch([]);
                  setApplyCloudSearch([]);
                  setApplyPortSearch([]);
                  setSelectedIds([]);
                }}
              >
                Remediated
              </a>
            </li> */}
            <li className="nav-item">
              <a
                className={`nav-link nav-table-tab ${category === "incorrect-ip" ? "active" : ""
                  }`}
                onClick={() => {
                  setCategory("incorrect-ip");
                  setPage(1);
                  setSearch("");
                  setApplyCountrySearch([]);
                  setApplyCloudSearch([]);
                  setApplyPortSearch([]);
                  setSelectedIds([]);
                }}
              >
                Incorrect IP
              </a>
            </li>
          </ul>
          <div className="card card_tableBox">
            <div className="body">
              <div className="header">
                <div className="filterBox">
                  <select
                    className="custom-select custom-select-sm form-control form-control-sm"
                    value={domainFilter}
                    onChange={(e) => { setDomainFilter(e.target.value); setPage(1) }}
                  >
                    <option value="all">All Domains</option>
                    {domain?.map((row, index) => {
                      return (
                        <option value={row}>{row?.toUpperCase()}</option>
                      );
                    })}
                  </select>
                  <div className="searchBoxInput p-0">
                    <input
                      class="form-control form-control-sm ml-0 my-1"
                      type="text"
                      placeholder="Search"
                      aria-label="Search"
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                        setPage(1);
                      }}
                    />
                  </div>
                  <ReactSelect
                    isMulti
                    placeholder="Select Port"
                    value={applyPortSearch?.map(port => ({ value: port, label: port?.toString() }))}
                    onChange={(selectedOptions) => {
                      const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                      setApplyPortSearch(values);
                      setPage(1);
                    }}
                    options={(lengthOfPort || []).map(port => ({ value: port, label: port?.toString() }))}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: '38px',
                        border: '1px solid #ced4da',
                        borderRadius: '4px'
                      })
                    }}
                  />
                  <ReactSelect
                    isMulti
                    placeholder="Country"
                    value={applyCountrySearch?.map(country => ({ value: country, label: country?.toString() }))}
                    onChange={(selectedOptions) => {
                      const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                      setApplyCountrySearch(values);
                      setPage(1);
                    }}
                    options={(lengthOfLocation || []).map(country => ({ value: country, label: country?.toString() }))}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: '38px',
                        border: '1px solid #ced4da',
                        borderRadius: '4px'
                      })
                    }}
                  />
                  <ReactSelect
                    isMulti
                    placeholder="Cloud Provider"
                    value={applyCloudSearch?.map(cloud => ({ value: cloud, label: cloud?.toString() }))}
                    onChange={(selectedOptions) => {
                      const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                      setApplyCloudSearch(values);
                      setPage(1);
                    }}
                    options={(lengthOfcloudLocations || []).map(cloud => ({ value: cloud, label: cloud?.toString() }))}
                    className="react-select-container"
                    classNamePrefix="react-select"
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: '38px',
                        border: '1px solid #ced4da',
                        borderRadius: '4px'
                      })
                    }}
                  />
                  
                  {ipCriticalityEnable && (
                    <ReactSelect
                      isMulti
                      placeholder="Criticality"
                      value={applyCriticality?.map(crit => ({ value: crit, label: crit }))}
                      onChange={(selectedOptions) => {
                        const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                        setApplyCriticality(values);
                        setPage(1);
                      }}
                      options={['Critical', 'High', 'Medium', 'Low'].map(crit => ({ value: crit, label: crit }))}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '4px'
                        })
                      }}
                    />
                  )}
                  <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                    <div style={{ position: 'relative', minWidth: '140px' }}>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="First Seen From"
                        value={from}
                        onChange={(e) => {
                          setFrom(e.target.value);
                          setPage(1);
                        }}
                        style={{
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '4px',
                          fontSize: '13px',
                          padding: '8px 12px',
                          backgroundColor: '#fff',
                          transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#007bff';
                          e.target.style.boxShadow = '0 0 0 0.2rem rgba(0,123,255,0.25)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#ced4da';
                          e.target.style.boxShadow = 'none';
                        }}
                      />
                      <label style={{
                        position: 'absolute',
                        top: '-18px',
                        left: '0',
                        fontSize: '11px',
                        fontWeight: '600',
                        color: '#495057',
                        marginBottom: '0',
                        letterSpacing: '0.3px'
                      }}>First Seen From</label>
                    </div>
                    <div style={{ position: 'relative', minWidth: '140px' }}>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="First Seen To"
                        value={till}
                        onChange={(e) => {
                          setTill(e.target.value);
                          setPage(1);
                        }}
                        style={{
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '4px',
                          fontSize: '13px',
                          padding: '8px 12px',
                          backgroundColor: '#fff',
                          transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#007bff';
                          e.target.style.boxShadow = '0 0 0 0.2rem rgba(0,123,255,0.25)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#ced4da';
                          e.target.style.boxShadow = 'none';
                        }}
                      />
                      <label style={{
                        position: 'absolute',
                        top: '-18px',
                        left: '0',
                        fontSize: '11px',
                        fontWeight: '600',
                        color: '#495057',
                        marginBottom: '0',
                        letterSpacing: '0.3px'
                      }}>First Seen To</label>
                    </div>
                  </div>
                  <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                    <div style={{ position: 'relative', minWidth: '140px' }}>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="Last Seen From"
                        value={updatedAtFrom}
                        onChange={(e) => {
                          setUpdatedAtFrom(e.target.value);
                          setPage(1);
                        }}
                        style={{
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '4px',
                          fontSize: '13px',
                          padding: '8px 12px',
                          backgroundColor: '#fff',
                          transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#007bff';
                          e.target.style.boxShadow = '0 0 0 0.2rem rgba(0,123,255,0.25)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#ced4da';
                          e.target.style.boxShadow = 'none';
                        }}
                      />
                      <label style={{
                        position: 'absolute',
                        top: '-18px',
                        left: '0',
                        fontSize: '11px',
                        fontWeight: '600',
                        color: '#495057',
                        marginBottom: '0',
                        letterSpacing: '0.3px'
                      }}>Last Seen From</label>
                    </div>
                    <div style={{ position: 'relative', minWidth: '140px' }}>
                      <input
                        type="date"
                        className="form-control"
                        placeholder="Last Seen To"
                        value={updatedAtTo}
                        onChange={(e) => {
                          setUpdatedAtTo(e.target.value);
                          setPage(1);
                        }}
                        style={{
                          minHeight: '38px',
                          border: '1px solid #ced4da',
                          borderRadius: '4px',
                          fontSize: '13px',
                          padding: '8px 12px',
                          backgroundColor: '#fff',
                          transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out'
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#007bff';
                          e.target.style.boxShadow = '0 0 0 0.2rem rgba(0,123,255,0.25)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = '#ced4da';
                          e.target.style.boxShadow = 'none';
                        }}
                      />
                      <label style={{
                        position: 'absolute',
                        top: '-18px',
                        left: '0',
                        fontSize: '11px',
                        fontWeight: '600',
                        color: '#495057',
                        marginBottom: '0',
                        letterSpacing: '0.3px'
                      }}>Last Seen To</label>
                    </div>
                  </div>
                  {selectedIds.length > 1 && category === "all" && userPermission && (
                    <Box sx={{ width: 160 }}>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={selectedValue}
                          onChange={(event) => {
                            setAction(event.target.value);
                            snooze("", event.target.value, '', currentTableData);
                          }}
                        >
                          <MenuItem value="pleaseSelect">
                            Snooze Options
                          </MenuItem>
                          <MenuItem
                            value="riskAccepted"
                            onClick={() => {
                              addModal();
                            }}
                          >
                            Risk Accepted
                          </MenuItem>
                          <MenuItem
                            value="markAsFalsePositive"
                            onClick={() => {
                              addModal();
                            }}
                          >
                            False Positive
                          </MenuItem>
                          <MenuItem value="markAsRemidiated">
                            Remediated
                          </MenuItem>
                          <MenuItem value="markAsIncorrectIp" onClick={() => {
                          }}>
                            Incorrect Ip
                          </MenuItem>
                          <MenuItem value="markAsCorrectIp" onClick={() => {
                          }}>
                            Correct Ip
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                  )}
                  {selectedIds.length > 1 &&
                    (category == "false-positive" ||
                      category == "risk-accepted") && (
                      <button
                        className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                        onClick={() => Unsnoozed("")}
                      >
                        Unsnooze
                      </button>
                    )}
                </div>

                <div className="table-responsive">
                  <table className="table table-custom spacing5 mb-0">
                    <thead>
                      <tr>
                        {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <th>
                              <input
                                type="checkbox"
                                checked={
                                  selectedIds == 0 ? false : multiCheckTrue
                                }
                                onClick={() => {
                                  multicheck(currentTableData);
                                }}
                                className="checkUncheck"
                              />
                            </th>
                          )}
                        {/* <th>#</th> */}
                        <th>IP Address</th>
                        <th>Location</th>
                        <th>Cloud / ISP Provider</th>
                        <th>Open Ports</th>
                        {ipCriticalityEnable && (
                          <th>Criticality</th>
                        )}
                        <th>Network Services</th>
                        <th>Operating System</th>
                        <th>Hosts</th>
                        {category !== "all" && <th>Action Note</th>}
                        <th>Created At</th>
                        <th>Updated At</th>
                        {/* <th>Actions</th> */}
                        {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                          category === "risk-accepted" ||
                          category === "false-positive") && (
                            <th style={{ width: "80" }}>Action</th>
                          )}
                      </tr>
                    </thead>
                    <tbody>
                      {currentTableData?.map((row, index) => {
                        const pageCount = (page - 1) * 10 + 1;
                        return (
                          <React.Fragment key={index}>
                            <tr onClick={onModalOpen}>
                              {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <td>
                                    <input
                                      onClick={() => singleClick(row?._id)}
                                      checked={selectedIds?.includes(row?._id)}
                                      type="checkbox"
                                      className="checkUncheck"
                                    />
                                  </td>
                                )}
                              {/* <td>
                                <span>{pageCount + index}</span>
                              </td> */}
                              <td>
                                <div className="d-flex align-items-center">
                                  <Tooltip text="Avatar Name" id="client1" />
                                  <Link to={`/asset/${row?._id}/${row?.ip}`}>
                                    <div
                                      style={{
                                        fontWeight: 400,
                                        fontSize: 14,
                                      }}
                                    >
                                      {row?.ip || "NA"}
                                    </div>
                                  </Link>
                                </div>
                              </td>
                              <td>{row?.location || "NA"}</td>
                              <td>{row?.cloudOrISPProvider || "NA"}</td>
                              {/* <td className="d-flex flex-wrap">
                                {row?.openPorts?.map((port) => {
                                  return <span className="badge d-inline-block m-1">{port}</span>;
                                })}
                              </td> */}
                              <td>
                                <div className="relative">
                                  <div className="d-flex flex-wrap">
                                    {(expandedRows.has(row.id) ? row?.openPorts : row?.openPorts?.slice(0, 5))?.map((port, index) => (
                                      <span key={index} className="badge d-inline-block m-1 badgeAssets">
                                        {port}
                                      </span>
                                    ))}
                                    {row?.openPorts?.length > 5 && (
                                      <div className="relative group">
                                        <span
                                          className="badge d-inline-block m-1 badgeAssets cursor-pointer"
                                          onClick={() => {
                                            setExpandedRows(prev => {
                                              const newSet = new Set(prev);
                                              if (newSet.has(row.id)) {
                                                newSet.delete(row.id);
                                              } else {
                                                newSet.add(row.id);
                                              }
                                              return newSet;
                                            });
                                          }}
                                        >
                                          {expandedRows.has(row.id) ? 'Show less' : `+${row.openPorts.length - 5} more`}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </td>
                              {ipCriticalityEnable && (
                                <td>{row?.highestSeverity || "NA"}
                                  {row?.highestSeverity !== "LOW" && row?.highestSeverity && (
                                    <p style={{ cursor: "pointer" }} onClick={() => riskOpen(row)}>(Detail)</p>
                                  )}
                                </td>
                              )}
                              <td>
                                {row?.networkServices?.length > 0 && row?.networkServices[0] !== "" ? (
                                  <div className="relative">
                                    <div className="d-flex flex-wrap">
                                      {(expandedServiceRows.has(row.id) ? row?.networkServices : row?.networkServices?.slice(0, 3))?.map((service, index) => (
                                        <span key={index} className="badge badge-warning badgeAssetsDark d-inline-block m-1">
                                          {service}
                                        </span>
                                      ))}
                                      {row?.networkServices?.length > 3 && (
                                        <div className="relative group">
                                          <span
                                            className="badge badge-warning badgeAssetsDark d-inline-block m-1 cursor-pointer"
                                            onClick={() => {
                                              setExpandedServiceRows(prev => {
                                                const newSet = new Set(prev);
                                                if (newSet.has(row.id)) {
                                                  newSet.delete(row.id);
                                                } else {
                                                  newSet.add(row.id);
                                                }
                                                return newSet;
                                              });
                                            }}
                                          >
                                            {expandedServiceRows.has(row.id) ? 'Show less' : `+${row.networkServices.length - 3} more`}
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  "N/A"
                                )}
                              </td>
                              <td>{row?.operatingSystem || "NA"}</td>
                              <td>
                                <Link to="#"
                                style={{ cursor: "pointer" }}
                                onClick={() => hostOpen(row)}
                                >
                                Host Detail
                                </Link>
                              </td>
                              {category !== "all" && <td style={{ whiteSpace: "unset" }}>{row?.actionNote ? row.actionNote : "N/A"}</td>}
                              <td>
                                {row?.createdAt
                                  ? moment(row?.createdAt).format(
                                    "DD-MM-YYYY"
                                  )
                                  : "NA"}
                              </td>
                              <td>
                                {row?.updatedAt
                                  ? moment(row?.updatedAt).format(
                                    "DD-MM-YYYY"
                                  )
                                  : "NA"}
                              </td>
                              {auth?.accessLevel != "Threat Analyst" && category === "all" && userPermission && (
                                <td>
                                  <Box sx={{ width: 160 }}>
                                    <FormControl fullWidth>
                                      <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={selectedValue}
                                        onChange={(event) => {
                                          setAction(event.target.value);
                                          snooze(
                                            row?._id,
                                            event.target.value,
                                            row?.ip,
                                            currentTableData
                                          );
                                        }}
                                      >
                                        <MenuItem value="pleaseSelect">
                                          Snooze Options
                                        </MenuItem>
                                        {/* <MenuItem
                                          value="riskAccepted"
                                          onClick={() => {
                                            addModal();
                                            setLookalikeAppId([row._id]);
                                          }}
                                        >
                                          Risk Accepted
                                        </MenuItem> */}
                                        {/* <MenuItem
                                          value="markAsFalsePositive"
                                          onClick={() => {
                                            addModal();
                                            setLookalikeAppId([row._id]);
                                          }}
                                        >
                                          False Positive
                                        </MenuItem> 
                                        {/* <MenuItem value="markAsRemidiated">
                                          Remediated
                                        </MenuItem> */}
                                        <MenuItem value="markAsIncorrectIp">
                                          Incorrect Ip
                                        </MenuItem>
                                        <MenuItem value="markAsCorrectIp">
                                          Correct Ip
                                        </MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Box>
                                </td>
                              )}
                              {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <td>
                                    <button
                                      className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                      onClick={() => Unsnoozed(row?._id)}
                                    >
                                      Unsnooze
                                    </button>
                                  </td>
                                )}
                            </tr>
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <div className="d-flex justify-content-between align-content-center">
                  <div className="dataTables_paginate">
                    {totalItems > 0 && (
                      <Pagination
                        className="pagination-bar"
                        currentPage={page}
                        totalCount={totalItems}
                        pageSize={limit}
                        onPageChange={(page) => setPage(page)}
                      />
                    )}
                  </div>
                  {totalItems > 10 && (
                    <select
                      value={limit}
                      onChange={(e) => {
                        setLimit(e.target.value);
                        setPage(1);
                      }}
                      className="form-control limitSelectBox"
                    >
                      <option value={10}>10 per page</option>
                      <option value={25}>25 per page</option>
                      <option value={50}>50 per page</option>
                      <option value={100}>100 per page</option>
                    </select>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModaltwo === "Form Wizard modal two" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {action == "markAsFalsePositive"
                  ? "Mark As False Positive"
                  : "Risk Accepted"}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModalTwo("");
                  setActionNote("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page modal_mob">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <label className="col-lg-6 col-md-12">Snooze for</label>
                      <div className="form-group ol-lg-12 col-md-12">
                        <select
                          className="custom-select custom-select-sm form-control form-control-sm"
                          onChange={(e) => setForValue(e.target.value)}
                        >
                          <option value="forever">Forever</option>
                          <option value="3 months">3 Months</option>
                          <option value="6 months">6 Months</option>
                          <option value="12 months">12 Months</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label className="col-lg-12 col-md-12">Detail</label>
                      <div className="form-group col-lg-12 col-md-12">
                        <textarea
                          onChange={(e) => setActionNote(e.target.value)}
                          value={actionNote}
                          className="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12"
                      style={{ marginRight: "28px" }}
                    >
                      <button
                        type="button"
                        style={{ color: "black", fontWeight: "bold" }}
                        onClick={submit}
                        className="btn btn-round btn-primary mr-1 pull-right"
                      >
                        Submit
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={() => {
                          setModalTwo("");
                          setActionNote("");
                        }}
                        className="btn btn-round btn-default pull-right"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModalhost === "Form Wizard modal host" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Hosts
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModalHost("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <table className="table table-custom spacing5 mb-0">
                    <thead>
                      <tr>
                        <th>Host</th>
                        <th>Last Updated on</th>
                      </tr>
                    </thead>
                    <tbody>
                      {hosts?.hosts?.map((host) => (
                        <tr key={host.subDomainName}>
                          <td>{host?.subDomainName || "N/A"}</td>
                          <td>
                            {moment(host?.updatedAt || "N/A").format(
                              "DD-MM-YYYY"
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModalhost === "Port Wizard modal host" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Risk Details
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModalHost("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Impact</th>
                          <th>Recommendations</th>
                        </tr>
                      </thead>
                      <tbody>
                        {hosts?.impacts?.map((impact, index) => (
                          <tr key={index}>
                            <td style={{ whiteSpace: 'pre-wrap' }}>{impact}</td>
                            <td style={{ whiteSpace: 'pre-wrap' }}>{hosts?.recommendations?.[index]}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModal ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg assetsDiscoveryModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {modalHeading}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page">
              <div id="wizard_horizontal">
                <section>
                  <div className="row">
                    <div className="col-sm-12">
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          downloadFile();
                        }}
                        href="/add-report"
                        style={{ float: "right" }}
                        className="btn btn-primary mr-1"
                      >
                        <i className="fa fa-file-excel-o"></i>
                      </a>
                    </div>
                  </div>
                  <div className="card">
                    {/* <div className="body"> */}
                    <div className="table-responsive">
                      { }
                    </div>
                    {/* </div> */}
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal fade Form-Wizard-modal ${certModal ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg assetsDiscoveryModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Certificate
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setCertModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page">
              <div id="wizard_horizontal">
                <section>
                  <div
                    className="card"
                    dangerouslySetInnerHTML={{
                      __html: certModalBody?.replace(/\n/g, "<br />"),
                    }}
                  >
                    {/* {certModalBody}
                    dangerouslySetInnerHTML={{__html: alert.alertContent}} */}
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div
        className={`modal fade  ${ipRemoveModal ? "d-block show" : ""}`}
        id="exampleModal"
        onClick={() => setIpRemoveModal(false)}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Delete
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-round btn-default"
                data-dismiss="modal"
                onClick={() => setIpRemoveModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-round btn-primary"
                onClick={() => {
                  deleteIp(ipId, id, false, dispatch);
                  setIpRemoveModal(false);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div
          className={`modal fade Form-Wizard-modal ${
            isModalTrue == true ? "d-block show" : ""
          }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Add New User
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setModalSet("")}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                  <div className="row clearfix">
                      <div className="col-lg-6 col-md-12">
                        <label className="col-lg-12 col-md-12">Primary Contact Name</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Primary Contact Name *"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <label className="col-lg-6 col-md-12">Email address</label>
                        <div className="form-group ol-lg-12 col-md-12">
                          <input
                            type="email"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      <div
        className={`modal fade Form-Wizard-modal ${isModalThree === "Form Wizard modalThree" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add IP Address
              </h5>
            </div>
            <div className="modal-body pricing_page">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card mb-3">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <div className="form-group d-flex">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="IP Address"
                          name="ips"
                          id="ips"
                          style={{ float: "left", width: "89%" }}
                        />
                        <button
                          type="button"
                          style={{ float: "left", minWidth: "auto", marginLeft: '5px', fontSize: '7px', padding: '6px 16px', fontWeight: '300' }}
                          className="btn btn-primary"
                          onClick={() => addIps()}
                        >
                          <i
                            className="fa fa-plus"
                            style={{ fontSize: "22px", color: "#fff" }}
                          ></i>
                        </button>
                      </div>
                      {Ips && Ips.length > 0 && (
                        <div>
                          {Ips?.map((keyword, index) => {
                            return (
                              <span className="addIpShowBox">
                                {keyword}{" "}
                                <span
                                  className="fa fa-times-circle"
                                  onClick={() =>
                                    removeKeyword(index)
                                  }
                                ></span>
                              </span>
                            );
                          })}
                        </div>)}
                    </div>
                    <div className="col-md-12 text-center d-flex justify-content-end align-items-center">
                      <button
                        type="button"
                        className="btn btn-round btn-primary cancelBtn mr-1"
                        onClick={() => {
                          setModalThree("");
                          setIps([]);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-round btn-primary"
                        onClick={() => {
                          submitIps()
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>
            
            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek continuously scans public-facing IP addresses and associated open ports
                  across on-premise, cloud, and CDN environments. Open ports increase the attack
                  surface and are commonly exploited for reconnaissance, lateral movement,
                  credential attacks, and service abuse.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Is Open Port Exposure</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      An open port represents a network service listening for inbound connections.
                      While some ports are required for business operations, unnecessary or
                      misconfigured open ports significantly increase the likelihood of exploitation.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What BrandSek Discovers</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Public IPs mapped to domains, cloud providers, and geolocation</li>
                      <li>Exposed TCP/UDP ports (e.g., 21, 22, 80, 443, 3389, 5432, 27017)</li>
                      <li>Identified network services (HTTP, HTTPS, FTP, SSH, SMTP, DB services)</li>
                      <li>Infrastructure hosted across AWS, GCP, Azure, CDNs, ISPs</li>
                      <li>Temporal visibility (first seen / last seen exposure)</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Common Risks Associated with Open Ports</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Unauthorized access to administrative services</li>
                      <li>Brute-force and credential-stuffing attacks</li>
                      <li>Exploitation of vulnerable services and legacy protocols</li>
                      <li>Information disclosure via banners or misconfigured services</li>
                      <li>Pivoting into internal networks</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Business & Compliance Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Uncontrolled port exposure can lead to data breaches, ransomware incidents,
                      service disruption, and regulatory non-compliance. Continuous monitoring supports
                      ISO 27001 network security controls, CERT-In advisories, and proactive attack
                      surface reduction.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Port Validation & Business Justification</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Verify if the open port is required for business operations</li>
                      <li>Identify the service running on the port</li>
                      <li>Confirm ownership and asset criticality</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.20 · Network Security</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Exposure & Threat Assessment</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Check for known vulnerable services or default configs</li>
                      <li>Assess internet-wide exposure and scan visibility</li>
                      <li>Correlate with CVE, exploit, and threat intel feeds</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.8 · Threat Intelligence</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Hardening & Remediation</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Close unused or unnecessary ports</li>
                      <li>Restrict access using firewall / security groups</li>
                      <li>Enforce strong authentication where required</li>
                    </ul>
                    <div className="compliance-tag">CERT-In · Network Hardening</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Monitoring & Closure</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Continuously monitor for port re-exposure</li>
                      <li>Validate remediation via rescans</li>
                      <li>Document acceptance for justified exposures</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.25 · Risk Management</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default AssetDiscovery;
